export default {
    buttons: {
        back: '上一页',
        home: '返回首页',
    },
};
